/** Read from env at call time rather than at module load so tests can set process.env before use —
 *  which is also why this does not delegate to `getBaseApiUrl()`. */
export function copilotBaseUrl(): string {
  return `${process.env.REACT_APP_API_URL ?? ''}/v3/copilot`
}
